import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useOrderGrowth, usePlatformFeeGrowth } from '@hooks/dashboard/useKapi';

const AvgOrderValueTrend: React.FC = () => {
  const { data: orderData, isLoading: ol } = useOrderGrowth();
  const { data: feeData, isLoading: fl } = usePlatformFeeGrowth();

  if (ol || fl) return <div className="chart-loading">Loading...</div>;

  // Compute avg order value from daily metrics: totalOrderValue / totalOrders
  // Since we have platform fees, we approximate using fee/fee_rate patterns
  const chartData = orderData && feeData
    ? orderData.map((o, i) => {
        const fee = feeData[i];
        const avgValue = o.totalOrders > 0 && fee ? (fee.platformFee / 0.05) / o.totalOrders : 0;
        return { date: o.date, avgValue: Math.round(avgValue) };
      })
    : Array.from({ length: 7 }, (_, i) => ({ date: `Day ${i+1}`, avgValue: 0 }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <LineChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false} />
        <XAxis dataKey="date" tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} tickFormatter={(v) => `₹${v}`} />
        <Tooltip
          contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12 }}
          formatter={(value: number) => [`₹${value}`, 'Avg Order Value']}
        />
        <Line type="monotone" dataKey="avgValue" stroke="#10B981" strokeWidth={2.5} dot={{ r: 3, fill: '#10B981' }} activeDot={{ r: 5, fill: '#10B981', stroke: '#fff', strokeWidth: 2 }} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AvgOrderValueTrend;
